import { Fragment, FunctionComponent, KeyboardEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { useTranslation } from "react-i18next";
import { bindActionCreators } from "@reduxjs/toolkit";
import { Button } from "@App/Components/Funnel/Button";
import { FunnelHeader } from "@App/Components/Funnel/FunnelHeader";
import { MileageInput } from "@App/Components/common/MileageInput";

export type MileageProps = {
  headline: string;
  step: number;
  maxSteps: number;
  onSubmit?: (mileage: number) => void;
};

export const Mileage: FunctionComponent<MileageProps> = ({
  headline,
  step,
  maxSteps,
  onSubmit,
}: MileageProps) => {
  const { t } = useTranslation();
  const mileage = useSelector((state: State) => state.orders.mileage);

  const dispatch = useDispatch();
  const { setMileage } = bindActionCreators(actionCreators, dispatch);

  const removeNonNumeric = (num: number) => num.toString().replace(/[^0-9]/g, "");

  const submit = (): void => {
    setMileage(parseInt(removeNonNumeric(mileage ?? 0)));
    onSubmit && onSubmit(parseInt(removeNonNumeric(mileage ?? 0)));
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (mileage && e.key === "Enter") {
      submit();
    }
  };

  return (
    <Fragment>
      <div className="container bg-white pt-10 pb-12">
        <FunnelHeader
          heading={headline}
          step={step}
          maxSteps={maxSteps}
          subheading={t("mileage.headline")}
          description={t("mileage.subheadline")}
        />
        <MileageInput
          value={mileage}
          onChange={setMileage}
          onKeyDown={handleKeyDown}
          placeholder="30.000"
          autoFocus
          className="md:w-1/3 w-full"
        />

        <Button title={t("mileage.submit")} disabled={mileage === null} onClick={submit} />
      </div>
    </Fragment>
  );
};
